import React from 'react';
import { HOLES } from './courseData';

const HoleNav = ({ hole, onSelect }) => (
  <div data-testid="hole-nav">
    <div className="font-montserrat text-white/45 text-[10px] tracking-[0.22em] uppercase mb-2">Trous</div>
    <div role="group" aria-label="Sélection du trou" className="grid grid-cols-9 gap-1.5">
      {HOLES.map((h) => {
        const on = hole === h.number;
        return (
          <button
            key={h.number}
            type="button"
            onClick={() => onSelect(h.number)}
            aria-pressed={on}
            aria-label={`Trou ${h.number}`}
            data-testid={`hole-nav-${h.number}`}
            className={`aspect-square w-full rounded-full border font-playfair text-sm sm:text-base leading-none flex items-center justify-center transition-all duration-300
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#c9a962] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0f2419]
              ${on
                ? 'bg-[#c9a962] border-[#c9a962] text-[#0f2419] shadow-[0_6px_18px_-6px_rgba(201,169,98,.8)]'
                : 'bg-white/[0.03] border-[#c9a962]/20 text-white/80 hover:border-[#c9a962]/60 hover:text-white hover:bg-white/[0.06]'}`}
          >
            {h.number}
          </button>
        );
      })}
    </div>
  </div>
);

export default HoleNav;
